import styled from "@emotion/styled";
import { Paper } from "@mui/material";

export type PaperStylesProps = {
  backgroundColor?: string | undefined;
  noPadding?: boolean;
  noMargin?: boolean;
};

const PaperStyles = styled(Paper)<PaperStylesProps>`
  background: ${(props) =>
    props.backgroundColor ? props.backgroundColor : "#fff"};
  border-radius: 16px;
`;

export { PaperStyles };
